import React, { Fragment } from 'react';
import { Col, Row, Card } from 'antd';
import { 
  SafetyOutlined, 
  CameraOutlined, 
  LockOutlined, 
  ThunderboltOutlined,
  StarOutlined,
  CheckCircleFilled
} from '@ant-design/icons';

const Commendation = () => {
  const features = [
    {
      title: "ضمانت کیفیت کالا",
      description: "تمامی کالاهای موجود دارای بالاترین استانداردهای کیفیت و مرغوب‌ترین مواد اولیه",
      icon: <SafetyOutlined />,
      accentColor: "#ff6b6b",
      iconGradient: "linear-gradient(135deg, #ff6b6b 0%, #ff8787 100%)"
    },
    {
      title: "چاپ طرح اختصاصی شما",
      description: "هر طرح، عکس یا لوگویی که مد نظر دارید را با دقت و کیفیت فوق‌العاده چاپ می‌کنیم",
      icon: <CameraOutlined />,
      accentColor: "#4ecdc4",
      iconGradient: "linear-gradient(135deg, #4ecdc4 0%, #6edfd7 100%)"
    },
    {
      title: "پرداخت امن",
      description: "مجهز به معتبرترین درگاه‌های پرداخت آنلاین با گارانتی امنیت تراکنش‌های مالی",
      icon: <LockOutlined />,
      accentColor: "#74b9ff",
      iconGradient: "linear-gradient(135deg, #74b9ff 0%, #a29bfe 100%)"
    },
    {
      title: "تحویل در سریع‌ترین زمان",
      description: "چاپ و ارسال سفارش‌ها در کوتاه‌ترین زمان ممکن با بسته‌بندی حرفه‌ای و ایمن",
      icon: <ThunderboltOutlined />,
      accentColor: "#fdcb6e",
      iconGradient: "linear-gradient(135deg, #fdcb6e 0%, #ffeaa7 100%)"
    }
  ];

  return (
    <Fragment>
      <div id="commendation" style={{ 
        marginTop: "60px",
        marginBottom: "60px",
        position: "relative",
        padding: "20px 0"
      }}>
        
        {/* Section Header */}
        <div style={{ textAlign: "center", marginBottom: "48px", position: "relative", zIndex: 1 }}>
          <div style={{
            display: "inline-block",
            background: "linear-gradient(135deg, #ffffff 0%, rgba(255,255,255,0.5) 100%)",
            width: "60px",
            height: "3px",
            borderRadius: "3px",
            marginBottom: "16px"
          }} />
          <h2 style={{
            fontFamily: "Yekan",
            fontSize: "2rem",
            color: "#ffffff",
            marginBottom: "12px",
            textShadow: "0 2px 4px rgba(0,0,0,0.1)",
            position: "relative"
          }}>
            چرا آقای چاپ؟

          </h2>
          <p style={{
            fontFamily: "Yekan",
            fontSize: "1rem",
            color: "rgba(255,255,255,0.8)",
            maxWidth: "500px",
            margin: "0 auto"
          }}>
            با اطمینان و آرامش خاطر سفارش خود را ثبت کنید
          </p>
        </div>

        <Row gutter={[24, 24]} style={{ 
          padding: "10px", 
          marginRight: "0px", 
          marginLeft: "0px", 
          alignItems: "stretch",
          position: "relative",
          zIndex: 1
        }}>
          {features.map((feature, index) => (
            <Col xs={{ span: 24 }} xl={{ span: 6 }} md={{ span: 12 }} key={index}>
              <Card
                hoverable
                className="commendation-card"
                style={{
                  background: "rgba(0, 0, 0, 0.25)",
                  backdropFilter: "blur(12px)",
                  border: `1px solid rgba(255, 255, 255, 0.15)`,
                  borderRadius: "20px",
                  height: "100%",
                  transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                  cursor: "pointer",
                  position: "relative",
                  overflow: "hidden",
                  boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)"
                }}
                bodyStyle={{ padding: "28px 20px" }}
              >
                {/* Animated background shine effect */}
                <div className="card-shine" style={{
                  position: "absolute",
                  top: 0,
                  left: "-100%",
                  width: "100%",
                  height: "100%",
                  background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.08), transparent)",
                  transition: "left 0.6s ease"
                }} />
                
                {/* Glow effect on hover */}
                <div className="card-glow" style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  width: "0",
                  height: "0",
                  borderRadius: "50%",
                  background: `radial-gradient(circle, ${feature.accentColor}20, transparent)`,
                  transition: "all 0.6s ease",
                  transform: "translate(-50%, -50%)",
                  pointerEvents: "none"
                }} />
                
                {/* Icon Section */}
                <div style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  marginBottom: "20px"
                }}>
                  <div style={{
                    background: feature.iconGradient,
                    width: "70px",
                    height: "70px",
                    borderRadius: "18px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "32px",
                    color: "white",
                    boxShadow: `0 8px 20px rgba(0, 0, 0, 0.2)`,
                    transform: "rotate(0deg)",
                    transition: "transform 0.3s ease"
                  }}
                  className="commendation-icon">
                    {feature.icon}
                  </div>
                  

                </div>

                {/* Title */}
                <h3 style={{
                  fontFamily: "Yekan",
                  fontSize: "1.2rem",
                  color: "#ffffff",
                  marginBottom: "12px",
                  marginTop: "0"
                }}>
                  {feature.title}
                </h3>

                {/* Description */}
                <p style={{
                  fontFamily: "Yekan",
                  fontSize: "0.85rem",
                  color: "rgba(255, 255, 255, 0.85)",
                  lineHeight: "1.8",
                  marginBottom: "0",
                  textAlign: "justify"
                }}>
                  {feature.description}
                </p>

                {/* Bottom decorative line with accent color */}
                <div style={{
                  position: "absolute",
                  bottom: 0,
                  right: 0,
                  width: "80px",
                  height: "3px",
                  background: `linear-gradient(90deg, ${feature.accentColor}, transparent)`,
                  borderRadius: "3px"
                }} />

                {/* Top right decorative dot */}
                <div style={{
                  position: "absolute",
                  top: "20px",
                  right: "20px",
                  width: "4px",
                  height: "4px",
                  borderRadius: "50%",
                  background: feature.accentColor,
                  opacity: 0.6
                }} />
              </Card>
            </Col>
          ))}
        </Row>
      </div>

      {/* Global CSS Styles */}
      <style dangerouslySetInnerHTML={{
        __html: `
          .commendation-card {
            transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
          }
          
          .commendation-card:hover {
            transform: translateY(-8px) !important;
            border-color: rgba(255, 255, 255, 0.3) !important;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3) !important;
          }
          
          .commendation-card:hover .commendation-icon {
            transform: rotate(5deg) scale(1.05) !important;
          }
          
          .commendation-card:hover .card-shine {
            left: 100% !important;
          }
          
          .commendation-card:hover .card-glow {
            width: 200px !important;
            height: 200px !important;
          }
          
          @media (max-width: 768px) {
            .commendation-card .commendation-icon {
              width: 55px !important;
              height: 55px !important;
              font-size: 26px !important;
            }
            
            .commendation-card h3 {
              font-size: 1.1rem !important;
            }
            
            .commendation-card p {
              font-size: 0.8rem !important;
            }
          }
          
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          
          .commendation-card {
            animation: fadeInUp 0.6s ease-out;
          }
        `
      }} />
    </Fragment>
  );
};

export default Commendation;